import React from 'react';
import { useLazyLoadQuery } from 'react-relay';

import { ListItemsQuery } from '../../graphql/ListItemsQuery';

interface LoaderParentListProps {
    type: string;
}

const LoaderParentList: React.FC<LoaderParentListProps> = ({ type }) => {
    useLazyLoadQuery(ListItemsQuery, { type }, { fetchPolicy: 'network-only' });

    return null;
};

export default LoaderParentList;
